import {
    ARRIVAL_AIRPORT_SELECTED,
    BAGGAGE_FILTER_SELECTED,
    FLIGHT_DURATION_CHANGE_UPDATE,
    FORWARD_TIME_CHANGE_UPDATE,
    FORWARD_TIME_TYPE_CHANGE,
    NO_NIGHT_TRANSFER_SELECT,
    RETURN_AIRPORT_SELECTED,
    RETURN_TIME_CHANGE_UPDATE,
    RETURN_TIME_TYPE_CHANGE,
    SELECT_CARRIER_FILTER,
    SELECT_TRANSFER_TIME_FILTER_UPDATE,
    STOP_AIRPORT_SELECTED,
    STOPS_SELECT
} from "../actions/FlightsActions";
import {put, select, takeEvery} from "redux-saga/effects";
import {disableAppliedFilter, enableAppliedFilter} from "../actions/FilterGroupsActions";
import {initialState as transferInitial} from "../reducers/filters/TransferTimeFilterReducer";
import {initialState as forwardTimeInitial} from "../reducers/filters/ForwardTimeFilterReducer";
import {initialState as returnTimeInitial} from "../reducers/filters/ReturnTimeFilterReducer";
import {initialState as stopsInitial} from "../reducers/filters/StopsFilterReducer";

function* applyFilter(initialStateCallback, type) {
    const state = yield select();
    if (initialStateCallback(state)) {
        yield put(disableAppliedFilter(type));
    } else {
        yield put(enableAppliedFilter(type));
    }
}

function* sagas() {
    const actions = [
        {
            action: SELECT_CARRIER_FILTER,
            type: 'carriers',
            callback: (state) => {
                return state.AirlinesFilterReducer.selected.length === 0;
            }
        },
        {
            action: SELECT_TRANSFER_TIME_FILTER_UPDATE,
            type: 'transfer',
            callback: (state) => {
                return state.TransferTimeFilterReducer.selected.length === transferInitial.selected;
            }
        },
        {
            action: FLIGHT_DURATION_CHANGE_UPDATE,
            type: 'duration',
            callback: (state) => {
                return state.FlightDurationFilterReducer.start === state.FlightDurationFilterReducer.startSelected &&
                    state.FlightDurationFilterReducer.end === state.FlightDurationFilterReducer.endSelected;
            }
        },
        {
            action: FORWARD_TIME_CHANGE_UPDATE,
            type: 'forwardTime',
            callback: (state) => {
                return state.ForwardTimeFilterReducer.start === forwardTimeInitial.start &&
                    state.FlightDurationFilterReducer.end === forwardTimeInitial.end &&
                    state.FlightDurationFilterReducer.type === forwardTimeInitial.type;
            }
        },
        {
            action: FORWARD_TIME_TYPE_CHANGE,
            type: 'forwardTime',
            callback: (state) => {
                return state.ForwardTimeFilterReducer.start === forwardTimeInitial.start &&
                    state.FlightDurationFilterReducer.end === forwardTimeInitial.end &&
                    state.FlightDurationFilterReducer.type === forwardTimeInitial.type;
            }
        },
        {
            action: RETURN_TIME_CHANGE_UPDATE,
            type: 'returnTime',
            callback: (state) => {
                return state.ReturnTimeFilterReducer.start === returnTimeInitial.start &&
                    state.ReturnTimeFilterReducer.end === returnTimeInitial.end &&
                    state.ReturnTimeFilterReducer.type === returnTimeInitial.type;
            }
        },
        {
            action: RETURN_TIME_TYPE_CHANGE,
            type: 'returnTime',
            callback: (state) => {
                return state.ReturnTimeFilterReducer.start === returnTimeInitial.start &&
                    state.ReturnTimeFilterReducer.end === returnTimeInitial.end &&
                    state.ReturnTimeFilterReducer.type === returnTimeInitial.type;
            }
        },
        {
            action: STOPS_SELECT,
            type: 'stops',
            callback: (state) => {
                return state.StopsFilterReducer.stops === stopsInitial.stops &&
                    state.StopsFilterReducer.noNightTransfer === stopsInitial.noNightTransfer;
            }
        },
        {
            action: NO_NIGHT_TRANSFER_SELECT,
            type: 'stops',
            callback: (state) => {
                return state.StopsFilterReducer.stops === stopsInitial.stops &&
                    state.StopsFilterReducer.noNightTransfer === stopsInitial.noNightTransfer;
            }
        },
        {
            action: ARRIVAL_AIRPORT_SELECTED,
            type: 'arrivalAirports',
            callback: (state) => {
                return state.ArrivalAirportsFilterReducer.selected.length === 0;
            }
        },
        {
            action: RETURN_AIRPORT_SELECTED,
            type: 'returnAirports',
            callback: (state) => {
                return state.ReturnAirportsFilterReducer.selected.length === 0;
            }
        },
        {
            action: STOP_AIRPORT_SELECTED,
            type: 'stopAirports',
            callback: (state) => {
                return state.StopAirportsFilterReducer.selected.length === 0;
            }
        },
        {
            action: BAGGAGE_FILTER_SELECTED,
            type: 'baggage',
            callback: (state) => {
                return state.BaggageFilterReducer.freeBaggage === false || (
                    state.BaggageFilterReducer.selected.included === true &&
                    state.BaggageFilterReducer.selected.excluded === true)
            }
        },
    ];

    for (let i = 0; i < actions.length; i++) {
        yield takeEvery(actions[i].action, applyFilter, actions[i].callback, actions[i].type);
    }
}

export default sagas;



// WEBPACK FOOTER //
// ./src/saga/appliedFiltersSaga.js